// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../admin/assets/css/style.lazy.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "/* Se deriva del tema admin */\n\n.menu .closeSession {\n    position: absolute;\n    bottom: 40px !important;\n}\n", ""]);
// Exports
module.exports = exports;
